import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import {
  zConnectionStatus,
  zContactSourceType,
  zFunction,
  zIndustry,
} from 'client/zod.gen';
import { zFiltersArray } from 'helpers/router';

// Filter dimensions are mirrored to the URL so the People page can be deep
// linked (e.g. from a user's event to their People page pre-filtered by event).
const executiveUserPeopleSearchSchema = z.object({
  company_id: zFiltersArray(),
  company_type: zFiltersArray(),
  connection_status: zFiltersArray(zConnectionStatus),
  event_uuid: zFiltersArray(),
  function_expertise: zFiltersArray(zFunction),
  industry_expertise: zFiltersArray(zIndustry),
  personal_tags: zFiltersArray(),
  source_type: zFiltersArray(zContactSourceType),
});

export type ExecutiveUserPeopleSearch = z.infer<
  typeof executiveUserPeopleSearchSchema
>;

export const Route = createFileRoute('/_private/_route/users/$userId/people')({
  validateSearch: executiveUserPeopleSearchSchema,
});
